export default __webpack_public_path__ + "static/media/poster6.27b17cee.png";